// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","756":"component---src-pages-privacy-policy-tsx"}[chunkId] + "-" + {"223":"cca0f643576218430af2","245":"69520ce91e53c726b56e","453":"931c1927f5be64d71c63","756":"0c0069c0553921ff1027"}[chunkId] + ".js";
};